// These are currently provision via ember_app/app/styles/fonts.sass
export const FONT_FAMILY_PATHWAY_GOTHIC_ONE = "'Pathway Gothic One', sans-serif";
export const FONT_FAMILY_LEAGUE_GOTHIC = "'League Gothic Variable', sans-serif";
export const FONT_FAMILY_ROBOTO = "Roboto";
